module.exports = __webpack_public_path__ + "static/img/home42.eb1dafd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home42.png
// module id = KeJE
// module chunks = 13